import { useAuth } from '@/contexts/AuthContext';
import { useLaunchDarkly } from '@/contexts/LaunchDarklyContext';
import { useEffect, useState } from 'react';

export const useHomeScreenFeatures = () => {
  const { ldClient, isInitialized } = useLaunchDarkly();
  const { session } = useAuth();
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    if (!isInitialized || !ldClient || !session?.user?.email) return;

    const checkAccess = async () => {
      const hasFeatureAccess = await ldClient.variation('enhanced-dashboard-access', false);
      setHasAccess(hasFeatureAccess);
    };

    checkAccess();

    return ldClient.on('change:enhanced-dashboard-access', (value) => {
      setHasAccess(value);
    });
  }, [ldClient, isInitialized, session?.user?.email]);

  return hasAccess;
}; 